/**
 * @desc 函数防抖
 * @param func 目标函数
 * @param wait 延迟执行毫秒数
 * @param immediate true - 立即执行， false - 延迟执行
 */
export function debounce(func, wait, immediate) {
    let timer;
    return function() {
        let context = this,
            args = arguments;

        if (timer) clearTimeout(timer);
        if (immediate) {
            let callNow = !timer;
            timer = setTimeout(() => {
                timer = null;
            }, wait);
            if (callNow) func.apply(context, args);
        } else {
            timer = setTimeout(() => {
                func.apply(context, args);
            }, wait)
        }
    }
}

/**
 * @desc 函数节流
 * @param func 函数
 * @param wait 延迟执行毫秒数
 * @param type 1 表时间戳版，2 表定时器版
 */
export function throttle(func, wait, type) {
    if (type === 1) {
        let previous = 0;
    } else if (type === 2) {
        let timeout;
    }
    return function() {
        let context = this;
        let args = arguments;
        if (type === 1) {
            let now = Date.now();
            if (now - previous > wait) {
                func.apply(context, args);
                previous = now;
            }
        } else if (type === 2) {
            if (!timeout) {
                timeout = setTimeout(() => {
                    timeout = null;
                    func.apply(context, args)
                }, wait)
            }
        }
    }
}
/**
 * 完整的价格格式化函数，包含整数部分和小数部分
 * @param {number|string} price - 价格值
 * @returns {object} 返回包含整数部分和小数部分的对象
 */
export function formatPriceWithParts(price) {
  // 参数验证
  if (price == null || price === '') {
    return {
      integerPart: '0',
      decimalPart: '00',
      formatted: '0.00'
    };
  }
  
  const num = parseFloat(price);
  
  if (isNaN(num)) {
    return {
      integerPart: '0',
      decimalPart: '00',
      formatted: '0.00'
    };
  }
  
  // 格式化价格[1](@ref)[4](@ref)
  const formatted = num.toFixed(2);
  const [integerPart, decimalPart] = formatted.split('.');
  
  // 添加千分位分隔符[1](@ref)[3](@ref)
  const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  
  return {
    integerPart: integerWithCommas,
    decimalPart: decimalPart || '00',
    formatted: `${integerWithCommas}.${decimalPart || '00'}`
  };
}
export function isEqual(a, b) {
    console.log(a,b,'aaabbb')
    console.log(Math.abs(a - b) < Number.EPSILON)
    return Math.abs(a - b) < Number.EPSILON;
}
